import styled, { x } from '@xstyled/styled-components';

export const Section = styled(x.section).attrs((props) => ({
	mx: 'auto',
	pb: { _: 14, md: 20 },
	...props,
}))`
	max-width: 1200;
`;
